import { render, staticRenderFns } from "./AgentUserIcon.vue?vue&type=template&id=6c78e404&scoped=true&"
import script from "./AgentUserIcon.vue?vue&type=script&lang=js&"
export * from "./AgentUserIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c78e404",
  null
  
)

export default component.exports